<template lang="pug">
    .tour(v-if="content")
        .tour__decore-wr.tour__decore-wr--1
            img.tour__decore.tour__decore--1(src="@/assets/img/decor/cube.svg" alt="decor")
        .tour__decore-wr.tour__decore-wr--2
            img.tour__decore.tour__decore--2(src="@/assets/img/decor/lightning.svg" alt="decor")
        .tour__decore-wr.tour__decore-wr--3
            img.tour__decore.tour__decore--3(src="@/assets/img/decor/straightedge.svg" alt="decor")
        .tour__decore-wr.tour__decore-wr--4
            img.tour__decore.tour__decore--4(src="@/assets/img/decor/glow-1.svg" alt="decor")
        .tour__illustration
            img.tour__background(src="@/assets/img/development.svg" alt="illustration")
            img.tour__cogwheel-1(src="@/assets/img/cogwheel-1.svg" alt="cogwheel")
            img.tour__cogwheel-2(src="@/assets/img/cogwheel-2.svg" alt="cogwheel")
</template>

<script>
    // @ is an alias to /src
    import '@/components/tour/tour.styl';
    import EventBus from '@/eventBus';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    export default {
        name: 'Tour',
        mixins: [AjaxHelpersVue],
        data() {
            return {
                content: null,
                objImages: [],
                imgHide: true,
            }
        },
        components: {
            SvgIcon,
        },
        created() {
            EventBus.$on('loadTourPage', params => {
                this.request(params.url, params);
            });

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },
        methods: {
            request(url, params) {
                this.req('TourPage:getTourPage', {url}, res => {
                    this.content = res.content;
                    EventBus.$emit('setMenuTopActiveClass', params.url, params.from);
                    EventBus.$emit('pagePreloaderHide');
                    this.$nextTick(() => {
                        $('.samedia').removeClass('samedia--hide');
                        $('.footer').removeClass('footer--hide');
                        $('.page__decore--12').removeClass('page__decore--hide-bottom');
                        $('.page__decore--11').removeClass('page__decore--hide-bottom');
                        $('.page__decore--10').removeClass('page__decore--hide-bottom');
                        this.parallax();
                    });
                }, 'tour');
            },
            parallax() {
                $(document).on('mousemove', event => {
                    let offsetX = event.clientX;
                    let offsetY = event.clientY;
                    $('.tour__decore-wr--1').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                    $('.tour__decore-wr--2').css('transform', `translate(${offsetX * -0.01}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00002}deg)`);
                    $('.tour__decore-wr--3').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00005}deg)`);
                    $('.tour__decore-wr--4').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * 0.015}px)`).find('img').css('transform', `rotate(${offsetX * offsetY *- 0.00002}deg)`);
                });
            }
        }
    }
</script>
